/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AssignRolesDto interface.
 */
export function instanceOfAssignRolesDto(value) {
    if (!('roleIds' in value) || value['roleIds'] === undefined)
        return false;
    return true;
}
export function AssignRolesDtoFromJSON(json) {
    return AssignRolesDtoFromJSONTyped(json, false);
}
export function AssignRolesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'roleIds': json['roleIds'],
    };
}
export function AssignRolesDtoToJSON(json) {
    return AssignRolesDtoToJSONTyped(json, false);
}
export function AssignRolesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'roleIds': value['roleIds'],
    };
}
//# sourceMappingURL=AssignRolesDto.js.map